<template>
    <div class="coach-stats-row">
        <div class="coach-stat">
            <span class="coach-stat-num">{{ format(students) }}</span>
            <span class="coach-stat-lbl">{{ $t('common.students') }}</span>
        </div>
        <div class="coach-stat">
            <span class="coach-stat-num">{{ format(groups) }}</span>
            <span class="coach-stat-lbl">{{ $t('common.groups') }}</span>
        </div>
        <div class="coach-stat">
            <span class="coach-stat-num">{{ format(teams) }}</span>
            <span class="coach-stat-lbl">{{ $t('common.teams') }}</span>
        </div>
        <div class="coach-stat">
            <span class="coach-stat-num" :class="{ risk: riskCount > 0 }">{{ format(riskCount) }}</span>
            <span class="coach-stat-lbl">{{ $t('company.stat_risk') }}</span>
        </div>
        <button-tooltip top :disabled="!isBest" :tooltip="$t('company.best_coach_month')">
            <template v-slot:activator="{ on, attrs }">
                <div class="coach-stat" v-bind="attrs" v-on="on">
                    <span class="coach-stat-num" :class="{ best: isBest, empty: !hasAdherence }">
                        {{ adherenceLabel }}
                    </span>
                    <span class="coach-stat-lbl">{{ $t('company.stat_adherence') }}</span>
                </div>
            </template>
        </button-tooltip>
    </div>
</template>

<script>
import ButtonTooltip from '@/components/common/ButtonTooltip'

export default {
    name: "CoachStatsRow",
    components: { ButtonTooltip },
    props: {
        students: {
            type: Number,
            default: null,
        },
        groups: {
            type: Number,
            default: null,
        },
        teams: {
            type: Number,
            default: null,
        },
        riskCount: {
            type: Number,
            default: null,
        },
        adherence: {
            type: Number,
            default: null,
        },
        isBest: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasAdherence(vm = this) {
            return typeof vm.adherence === 'number'
        },
        adherenceLabel(vm = this) {
            return vm.hasAdherence ? `${vm.adherence}%` : '—'
        },
    },
    methods: {
        format(value) {
            return typeof value === 'number' ? value : '—'
        },
    },
}
</script>

<style scoped>
.coach-stats-row {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    padding: 12px 4px 0;
}

.coach-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 34px;
}

.coach-stat-num {
    font-size: 15px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--v-secondary-base);
    line-height: 1.2;
}

.coach-stat-num.risk {
    color: var(--v-error-base);
}

.coach-stat-num.empty {
    color: var(--v-txtMuted-base);
}

.theme--dark .coach-stat-num.best {
    color: var(--v-primary-base);
}

.theme--light .coach-stat-num.best {
    color: var(--v-accent-base);
}

.coach-stat-lbl {
    font-size: 9px;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-top: 1px;
    white-space: nowrap;
}
</style>
